import { createSelector } from 'reselect'

const getSchoolsData = state => state.FSUTeacher.schools

const getTeacherFSUState = state => state.FSUTeacher.state

const getSearchRequest = state => state.FSUTeacher.schoolSearchRequest

const getFinishAsParentRequest = state => state.FSUTeacher.finishAsParentRequest

const getFoundSchools = createSelector(
  [getSchoolsData],
  schoolsData => schoolsData.result
)

const getSearchValue = createSelector(
  [getSchoolsData],
  schoolsData => schoolsData.searchValue
)

const getSelectedSchool = createSelector(
  [getTeacherFSUState],
  fsuState => fsuState.school
)

const isNewSchool = createSelector(
  [getTeacherFSUState],
  fsuState => fsuState.newSchool
)

export {
  getFoundSchools,
  getSearchValue,
  getSelectedSchool,
  isNewSchool,
  getSearchRequest,
  getFinishAsParentRequest
}
